import * as a from "react";
const t = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ a.createElement("path", { d: "M21.47 11.489a.3.3 0 0 0-.3-.3H7l-1.883-.055 5.248-5.249a1.2 1.2 0 0 0 0-1.697.3.3 0 0 0-.424 0l-6.97 6.97a1.2 1.2 0 0 0 0 1.697l6.97 6.97a.3.3 0 0 0 .424 0 1.2 1.2 0 0 0 0-1.698l-5.38-5.38L7 12.688h13.27a1.2 1.2 0 0 0 1.2-1.2Z" }));
export {
  t as default
};
//# sourceMappingURL=back-icon-C6DDMlcB.js.map
